// Matter-tag filter view — same chrome as practice view.
// Ported from prototype's view.kind === "tag" branch.

import { useParams } from "react-router-dom";
import { firmTagById } from "../../data/firm-config";
import { matterClient, mattersByTag } from "../../data/matters";
import { practiceAreaById } from "../../data/practice-areas";
import { usePageTrail } from "../chrome/trail";
import { EntityLink } from "../chrome/EntityLink";
import { FixtureNotice } from "../chrome/FixtureNotice";

export function TagView() {
  const { tagId } = useParams<{ tagId: string }>();
  const tag = tagId ? firmTagById(tagId) : undefined;
  usePageTrail([{ label: "Tags" }, { label: tag?.label ?? "Tag" }]);
  if (!tag) return <div style={{ padding: 40 }}>Tag not found.</div>;

  return (
    <main className="cc-main">
      <div className="cc-body">
        {/* Tags do not exist on any server model yet, so every row below
            is the prototype's - say so until the firm gets real tags. */}
        <FixtureNotice>
          This tag view still runs on prototype data - the firm database has no tags yet.
        </FixtureNotice>
        <div className="cc-card" style={{ padding: 18 }}>
          <div style={{ fontSize: 16, fontWeight: 600 }}>{tag.label}</div>
          {tag.note && (
            <div style={{ fontSize: 12, color: "var(--muted)", marginTop: 6, fontStyle: "italic" }}>
              {tag.note}
            </div>
          )}
        </div>
        <div className="cc-card">
          <div className="cc-card-head">
            <div className="cc-card-title">Matters tagged "{tagId}"</div>
          </div>
          <div>
            {mattersByTag(tagId!).map((m) => {
              const c = matterClient(m);
              const pa = practiceAreaById(m.practiceArea);
              return (
                <div
                  key={m.eID}
                  style={{
                    display: "grid",
                    gridTemplateColumns: "auto 1fr auto",
                    gap: 14,
                    padding: "10px 18px",
                    borderTop: "1px solid var(--line-2)",
                    alignItems: "center",
                  }}
                >
                  <span className="pa-dot lg" style={{ background: pa?.accent }} />
                  <div>
                    <div style={{ fontSize: 13, fontWeight: 550 }}>
                      {c ? (
                        <EntityLink kind="client" id={c.id} subtle>
                          {c.name}
                        </EntityLink>
                      ) : (
                        "(unknown)"
                      )}
                    </div>
                    <div style={{ fontSize: 11, color: "var(--muted)" }}>
                      {pa && (
                        <>
                          <EntityLink kind="practiceArea" id={pa.id} subtle>
                            {pa.label}
                          </EntityLink>
                          {" · "}
                        </>
                      )}
                      <EntityLink kind="matter" id={m.eID} eID={m.eID} subtle>
                        <span className="tnum-mono">{m.eID}</span>
                      </EntityLink>
                    </div>
                  </div>
                  <EntityLink
                    kind="matter"
                    id={m.eID}
                    eID={m.eID}
                    subtle
                    style={{ fontSize: 11, color: "var(--muted)" }}
                  >
                    {m.stage}
                  </EntityLink>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </main>
  );
}
